export default [
  {
    path: "/criminalCases",
    component: () => import("./layout"),
    children: [
      {
        path: "/criminalCases",
        name: "criminalCases.index",
        component: () => import("./index"),
      },
    ],
  },
];
